import init from './thing'

const video =
{
    ...init
};

export default video ;
